import { Reveal } from "./Reveal";
import { img, srcSet } from "@/lib/media";
import { useLang } from "@/lib/i18n";

const FIVE_BELOW = "images/corporate-events/corporate-events-31.jpg";
const MILANJ = "images/corporate-events/corporate-events-18.jpg";
const DFW = "images/corporate-events/corporate-events-46.jpg";
const VAN_SAINT = "images/corporate-events/van-saint-group-logo.png";
const CLIENTS = [
  ["Five Below"], ["Milanj Diamonds"],
  ["DFW Event Design", "https://www.dfweventdesign.com/"], ["Van Saint Group", "https://www.vansaintgroup.com/"],
];
const ABOUT = "images/weddings/weddings-27.jpg";

export const Corporate = () => {
  const { t } = useLang();
  return (
    <section className="corp" id="corporate" data-testid="corporate-section">
      <div className="wrap">
        <Reveal>
          <h2>{t.corp.h}</h2>
          <div className="clients" data-testid="corporate-clients">
            {CLIENTS.map(([n, url]) => (url
              ? <a key={n} href={url} target="_blank" rel="noopener noreferrer" data-testid={`client-link-${n.split(" ")[0].toLowerCase()}`}>{n}</a>
              : <span key={n}>{n}</span>))}
          </div>
          <p className="lede">{t.corp.lede}</p>
          <p style={{ marginTop: 32 }}><a className="btn" href="#inquire" data-testid="corporate-inquire-btn">{t.corp.cta}</a></p>
        </Reveal>
        <Reveal delay={0.1} className="pics">
          <img src={img(FIVE_BELOW, 960)} srcSet={srcSet(FIVE_BELOW)} sizes="(max-width:900px) 50vw, 280px" alt={t.corp.alt1} loading="lazy" />
          <img src={img(MILANJ, 960)} srcSet={srcSet(MILANJ)} sizes="(max-width:900px) 50vw, 280px" alt={t.corp.alt2} loading="lazy" />
          <div className="pic-wrap" data-testid="client-photo-dfw">
            <img src={img(DFW, 960)} srcSet={srcSet(DFW)} sizes="(max-width:900px) 50vw, 280px" alt={t.corp.alt3} loading="lazy" />
            <a className="logo-badge" href="https://www.dfweventdesign.com/" target="_blank" rel="noopener noreferrer" data-testid="client-logo-dfw">
              <img src="/dfw-logo.webp" alt="DFW Event Design logo" width="500" height="208" loading="lazy" />
            </a>
          </div>
          <a href="https://www.vansaintgroup.com/" target="_blank" rel="noopener noreferrer" data-testid="client-logo-vansaint">
            <img src={img(VAN_SAINT, 960)} alt={t.corp.alt4} loading="lazy" />
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export const About = () => {
  const { t } = useLang();
  return (
    <section className="about" id="about" data-testid="about-section">
      <div className="wrap">
        <Reveal>
          <img src={img(ABOUT, 960)} srcSet={srcSet(ABOUT)} sizes="(max-width:900px) 100vw, 450px" alt={t.about.alt} loading="lazy" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2>{t.about.h}</h2>
          <p className="eyebrow">{t.about.eyebrow}</p>
          <p className="lede">{t.about.p1}</p>
          <p className="lede">{t.about.p2}</p>
          <p className="lede">{t.about.call} <a href="tel:+13027405585" data-testid="about-phone-link">302-740-5585</a> {t.about.or} {t.about.end}</p>
          <p style={{ marginTop: 32 }}><a className="btn" href="#inquire" data-testid="about-inquire-btn">{t.about.cta}</a></p>
        </Reveal>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer">
      <div className="wrap">
        <div><img src="/logo.png" alt="Flowers by Tino" /></div>
        <div data-testid="footer-contact">74584 Nevada Cir E<br />Palm Desert, California 92260<br />
          <a href="tel:+13027405585" data-testid="footer-phone">302-740-5585</a></div>
        <div><a href="https://www.instagram.com/flowers_by_tino/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">Instagram</a> &middot; <a href="https://www.facebook.com/FlowersbyTino" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook">Facebook</a><br />{t.footer.speak}</div>
      </div>
    </footer>
  );
};
